module.exports = __webpack_public_path__ + "img/bcel.e837f1a6.png";